import React, { useState } from "react";
import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Checkbox, CheckboxChangeEvent, Form, Input, Modal, Select } from "antd";
import "./transaction_invoice.css";
import { useTransactionInvoiceLogic } from "../../components/hoc_transaction_invoice";
import DataInvoiceForTransInvoice from "./data_invoice_for_trans_invoice";

const TransactionInvoice: React.FC = () => {

    const {
        transformStyle,
        onChange,
        form,
        isModalVisible,
        isPaidOff,
        showModal,
        handleCancel,
        handleRowSelect,
        handleAmountChange,
        handlePaidOffChange,
        handleSubmit,
    } = useTransactionInvoiceLogic();

    return (

        <div id="ilqt" style={transformStyle}>
            <div className="gjs-grid-row" id="i3aq">
                <div className="gjs-grid-column" id="ifqp">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/browser_transaction_invoice",
                                title: (
                                    <>
                                        <span>Browser Transaction Invoice</span>
                                    </>
                                ),
                            },
                            {
                                title: "Transaction Invoice",
                            },
                        ]}
                    />
                </div>
            </div>

            <div className="gjs-grid-row" id="ip7sv">
                <div className="gjs-grid-column" id="iot1">
                    <Button className="gr-button" onClick={handleSubmit}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                clipRule="evenodd"
                            />
                            <path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
                        </svg>
                        Submit
                    </Button>
                </div>
            </div>
            <div className="gjs-grid-row" id="idki">
                <div className="gjs-grid-column" id="ii2j">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item
                            label="ID Trans"
                            name="id_trans"
                            style={{
                                marginBottom: "5px",
                                width: "70%",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Date Trans"
                            name="date_trans"
                            style={{
                                marginBottom: "5px",
                                width: "68%",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Transaction Type"
                            name="trans_type"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Please select transaction type!' }]}
                        >
                            <Select
                                showSearch
                                placeholder="Select Transaction Type"
                                optionFilterProp="label"
                                onChange={onChange}
                                options={[
                                    { value: "1", label: "Pembayaran Invoice" },
                                    { value: "2", label: "Pembayaran Invoice DP" },
                                ]}
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Invoice No"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <Form.Item name="invoice_no" noStyle style={{ width: "85%" }}>
                                    <Input placeholder="" style={{ width: "90%" }} />
                                </Form.Item>
                                <Button
                                    type="primary"
                                    id="data_invoice_for_trans_invoice"
                                    onClick={showModal}
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            style={{
                                                width: "40px",
                                                height: "20px",
                                            }}
                                        >
                                            <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                            <path
                                                fillRule="evenodd"
                                                d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                                clipRule="evenodd"
                                            />
                                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                        </svg>
                                    }
                                />
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="Transaction To"
                            name="transaction_to"
                            style={{
                                marginBottom: "5px",
                                width: "38%"
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Warehouse"
                            name="warehouse"
                            style={{
                                marginBottom: "5px",
                                width: "80%"
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="TOP"
                            name="top"
                            style={{
                                marginBottom: "5px",
                                width: "70%",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Amount"
                            style={{
                                marginBottom: "5px",
                                paddingTop: "40px",
                                width: "80%",
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                               <Form.Item name="amount" noStyle rules={[{ required: true, message: 'Please input amount!' }]}>
                                    <Input
                                        placeholder=""
                                        style={{
                                            backgroundColor: '#ffd3d3ff',
                                            fontWeight: 'bold',
                                            fontSize: '16px'
                                        }}
                                        onChange={handleAmountChange}
                                    />
                                </Form.Item>
                                <Checkbox checked={isPaidOff} onChange={handlePaidOffChange}>Lunas</Checkbox>
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="Balance"
                            name="saldo_akhir"
                            style={{
                                marginBottom: "5px",
                                width: "65%",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                         <Form.Item
                            label="Remark"
                            name="remark"
                            style={{
                                marginBottom: "5px",
                                width: "100%",
                            }}
                        >
                            <Input.TextArea rows={4} placeholder="" />
                        </Form.Item>
                    </Form>

                </div>
            </div>
            <Modal
                title="Data Invoice"
                open={isModalVisible}
                onCancel={handleCancel}
                footer={null}
                width="70%"
                style={{ top: 150 }}
            >
                <DataInvoiceForTransInvoice onRowSelect={handleRowSelect} />
            </Modal>
        </div>
    );
};

export default TransactionInvoice;
